import React, { useState, JSX } from 'react';

import { TextareaWithConfirm, RadioOptionsWithConfirm, CardContainer, CardWithModal } from 'shared-components';

import QuestionPage from '../../../templates/question';
import OtherVisas from './visas/other';
import VisaRefusals from './visas/refusals';
import NonUKVisaRefusals from './visas/nonUkRefusals';
import { saveHistory } from '../../../../store/student/actions';
import { createUpdateHistoryFieldAction } from '../../../../store/student/history/actions';
import { Pages } from '../../../../store/student/history/types';

import { Q } from '../../../../store/student/types';
import {
  InputFieldConfig,
  IStudentOtherVisa,
  IStudentVisaRefusal,
  IStudentNonUKVisaRefusal,
  IStudentConfig,
} from '../../../../types';
import { useDispatch } from 'react-redux';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { Action } from 'redux';
import { getVisaLabelFromValue } from 'shared-components';
export interface IProps {
  sectionTitle: string;
  complete: boolean;
  currentStep: number;
  steps: number;
  hasOtherUkVisas?: boolean;
  prevUKOtherVisaVisible: boolean;
  prevUKOtherVisaConfig: InputFieldConfig;
  otherUkVisas: Array<IStudentOtherVisa>;
  hasLeaveToRemain?: boolean;
  ukLeaveToRemainVisible: boolean;
  ukLeaveToRemainConfig: InputFieldConfig;
  hasBorderRefusal?: boolean;
  prevRejectionsVisible: boolean;
  prevRejectionsConfig: InputFieldConfig;
  borderRefusalReason?: string;
  prevRejectionReasonVisible: boolean;
  prevRejectionReasonConfig: InputFieldConfig;
  hasUkVisaRefusals?: boolean;
  prevVisaRefusalVisible: boolean;
  prevVisaRefusalConfig: InputFieldConfig;
  ukVisaRefusals: Array<IStudentVisaRefusal>;
  hasOtherVisaRefusals?: boolean;
  prevNonUKVisaRefusalVisible: boolean;
  prevNonUKVisaRefusalConfig: InputFieldConfig;
  otherVisaRefusals: Array<IStudentNonUKVisaRefusal>;
  config: IStudentConfig;
}

type ICustomProps = IProps;

const HistoryQPage2 = (props: ICustomProps): JSX.Element => {
  const dispatch = useDispatch();

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onNext = (config: IStudentConfig): Action => dispatch(saveHistory(Pages.PAGE2, config));

  const onChange = (fieldName: string, value: unknown): Action =>
    dispatch(createUpdateHistoryFieldAction(fieldName, value));

  const onBackToTaskList = (): void => navigateToStudentDashboard();

  const [showModalOtherVisas, setShowModalOtherVisas] = useState([...props.otherUkVisas.map(_ => false), false]);
  const [otherUkVisas, setOtherUkVisas] = useState([
    ...(props.otherUkVisas?.length ? props.otherUkVisas : []),
    { visaType: '', year: '' },
  ]);

  const [showModalVisasRefusals, setShowModalVisasRefusals] = useState([
    ...props.ukVisaRefusals.map(_ => false),
    false,
  ]);
  const [ukVisaRefusals, setUkVisasRefusals] = useState([
    ...(props.ukVisaRefusals?.length ? props.ukVisaRefusals : []),
    { visaType: '', year: '' },
  ]);

  const [showModalOtherVisaRefusals, setShowModalOtherVisaRefusals] = useState([
    ...props.otherVisaRefusals.map(_ => false),
    false,
  ]);
  const [otherVisaRefusals, setOtherVisaRefusals] = useState([
    ...(props.otherVisaRefusals?.length ? props.otherVisaRefusals : []),
    { country: '', year: '', isStudentVisa: undefined },
  ]);

  const toggleModal = (
    index: number,
    showModalsArray: Array<boolean>,
    cb: React.Dispatch<React.SetStateAction<boolean[]>>,
  ): void => {
    const newShowModal = [...showModalsArray];
    newShowModal[index] = !showModalsArray[index];
    cb(newShowModal);
  };

  const deleteVisa = <T extends IStudentNonUKVisaRefusal | IStudentOtherVisa | IStudentVisaRefusal>(
    index: number,
    arrayOfValues: Array<T>,
    target: Q,
    cdForArray: React.Dispatch<React.SetStateAction<Array<T>>>,
    cdForModals: React.Dispatch<React.SetStateAction<boolean[]>>,
    additionalElement: T,
  ): void => {
    const newArrayOfValues = [...arrayOfValues];
    onChange(target, [...newArrayOfValues.slice(0, index), ...newArrayOfValues.slice(index + 1)]);

    cdForArray([...[...newArrayOfValues.slice(0, index), ...newArrayOfValues.slice(index + 1)], additionalElement]);
    cdForModals([
      ...[...newArrayOfValues.slice(0, index), ...newArrayOfValues.slice(index + 1)].map(_ => false),
      false,
    ]);
  };

  const handleYesNoClick = (target: Q, question: { char: string; label: string; selected: boolean }): void => {
    onChange(target, question.char === 'Y');
  };

  return (
    <QuestionPage
      complete={props.complete}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      {props.prevUKOtherVisaVisible && (
        <RadioOptionsWithConfirm
          key={Q.PREV_UK_OTHER_VISA}
          id={Q.PREV_UK_OTHER_VISA}
          label={'Have you been granted any other visas (non-student) for the UK in your lifetime?'}
          inputHelperText={props.prevUKOtherVisaConfig?.helpText}
          onClick={(question: { char: string; label: string; selected: boolean }) =>
            handleYesNoClick(Q.PREV_UK_OTHER_VISA, question)
          }
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasOtherUkVisas === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasOtherUkVisas === false,
            },
          ]}
        />
      )}

      {props.hasOtherUkVisas && (
        <CardContainer title={`Other UK Visas`}>
          {otherUkVisas.map((visa: IStudentOtherVisa, index: number) => (
            <CardWithModal
              key={index}
              id={`other-visa-${index}`}
              index={index}
              modalTitle={'Add an Other UK Visa'}
              additionalDataSelectorName={'other-visa'}
              cardTitle={getVisaLabelFromValue(visa.visaType)}
              cardItems={[
                {
                  label: 'Year',
                  value: visa.year,
                },
              ]}
              onRemove={(removeIndex: number) =>
                deleteVisa<IStudentOtherVisa>(
                  removeIndex,
                  [...props.otherUkVisas],
                  Q.PREV_UK_OTHER_VISAS,
                  setOtherUkVisas,
                  setShowModalOtherVisas,
                  { visaType: '', year: '' },
                )
              }
              addButtonLabel={`Add Other UK VISA`}
              addAnotherButtonLabel={`I have another visa to add`}
              hasAddMoreButton={visa.visaType === '' && visa.year === ''}
              showModal={showModalOtherVisas[index]}
              toggleModal={(value: number) => toggleModal(value, showModalOtherVisas, setShowModalOtherVisas)}
            >
              <OtherVisas
                index={index}
                visaType={visa.visaType}
                year={visa.year}
                onSaveAndClose={(visaOnSave: IStudentOtherVisa) => {
                  const stateOtherUkVisas = [...otherUkVisas];
                  stateOtherUkVisas.pop();
                  const newOtherUkVisas = [...props.otherUkVisas];
                  newOtherUkVisas[index] = {
                    ...visaOnSave,
                  };
                  onChange(Q.PREV_UK_OTHER_VISAS, newOtherUkVisas);
                  if (JSON.stringify(stateOtherUkVisas) !== JSON.stringify(newOtherUkVisas)) {
                    setOtherUkVisas([...(newOtherUkVisas?.length ? newOtherUkVisas : []), { visaType: '', year: '' }]);
                    setShowModalOtherVisas([...newOtherUkVisas.map(_ => false), false]);
                  }
                  toggleModal(index, showModalOtherVisas, setShowModalOtherVisas);
                }}
              />
            </CardWithModal>
          ))}
        </CardContainer>
      )}

      {props.ukLeaveToRemainVisible && (
        <RadioOptionsWithConfirm
          key={Q.UK_LEAVE_TO_REMAIN}
          id={Q.UK_LEAVE_TO_REMAIN}
          value={props.hasLeaveToRemain}
          label={'Have you made an application to the Home Office to enter or remain in the UK in the last 10 years?'}
          inputHelperText={props.ukLeaveToRemainConfig?.helpText}
          onClick={(question: { char: string; label: string; selected: boolean }) =>
            handleYesNoClick(Q.UK_LEAVE_TO_REMAIN, question)
          }
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasLeaveToRemain === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasLeaveToRemain === false,
            },
          ]}
        />
      )}

      {props.prevRejectionsVisible && (
        <RadioOptionsWithConfirm
          key={Q.PREVIOUS_VISA_REJECTION}
          id={Q.PREVIOUS_VISA_REJECTION}
          label={'Have you been refused entry to the UK at the border in your lifetime?'}
          inputHelperText={props.prevRejectionsConfig?.helpText}
          onClick={(question: { char: string; label: string; selected: boolean }) =>
            handleYesNoClick(Q.PREVIOUS_VISA_REJECTION, question)
          }
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasBorderRefusal === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasBorderRefusal === false,
            },
          ]}
        />
      )}

      {props.prevRejectionReasonVisible && (
        <TextareaWithConfirm
          key={Q.PREVIOUS_VISA_REJECTION_REASON}
          id={Q.PREVIOUS_VISA_REJECTION_REASON}
          value={props.borderRefusalReason}
          label={`Please provide more information`}
          inputHelperText={props.prevRejectionReasonConfig?.helpText}
          onChange={evt => onChange(Q.PREVIOUS_VISA_REJECTION_REASON, evt.currentTarget.value)}
        />
      )}

      {props.prevVisaRefusalVisible && (
        <RadioOptionsWithConfirm
          key={Q.PREV_VISA_REFUSAL}
          id={Q.PREV_VISA_REFUSAL}
          label={'Have you previously received a visa refusal from the UK in your lifetime?'}
          inputHelperText={props.prevVisaRefusalConfig?.helpText}
          onClick={(question: { char: string; label: string; selected: boolean }) =>
            handleYesNoClick(Q.PREV_VISA_REFUSAL, question)
          }
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasUkVisaRefusals === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasUkVisaRefusals === false,
            },
          ]}
        />
      )}

      {props.hasUkVisaRefusals && (
        <CardContainer title={`UK Visa Refusals`}>
          {ukVisaRefusals.map((visa: IStudentVisaRefusal, index: number) => (
            <CardWithModal
              key={index}
              id={`visa-refusal-${index}`}
              index={index}
              modalTitle={'Add a UK Visa Refusal'}
              additionalDataSelectorName={'visa-refusal'}
              cardTitle={`${getVisaLabelFromValue(visa.visaType)} Visa Refusal`}
              cardItems={[
                {
                  label: 'Year',
                  value: visa.year,
                },
              ]}
              onRemove={(removeIndex: number) =>
                deleteVisa<IStudentVisaRefusal>(
                  removeIndex,
                  [...props.ukVisaRefusals],
                  Q.PREV_VISA_REFUSALS,
                  setUkVisasRefusals,
                  setShowModalVisasRefusals,
                  { visaType: '', year: '' },
                )
              }
              addButtonLabel={`Add UK Visa Refusal`}
              addAnotherButtonLabel={`I have another visa refusal to add`}
              hasAddMoreButton={visa.visaType === '' && visa.year === ''}
              toggleModal={(value: number) => toggleModal(value, showModalVisasRefusals, setShowModalVisasRefusals)}
              showModal={showModalVisasRefusals[index]}
            >
              <VisaRefusals
                index={index}
                visaType={visa.visaType}
                year={visa.year}
                onSaveAndClose={(visaOnSave: IStudentVisaRefusal) => {
                  const stateUkVisaRefusals = [...ukVisaRefusals];
                  stateUkVisaRefusals.pop();
                  const newUkVisaRefusals = [...props.ukVisaRefusals];
                  newUkVisaRefusals[index] = {
                    ...visaOnSave,
                  };
                  onChange(Q.PREV_VISA_REFUSALS, newUkVisaRefusals);
                  if (JSON.stringify(stateUkVisaRefusals) !== JSON.stringify(newUkVisaRefusals)) {
                    setUkVisasRefusals([
                      ...(newUkVisaRefusals?.length ? newUkVisaRefusals : []),
                      { visaType: '', year: '' },
                    ]);
                    setShowModalVisasRefusals([...newUkVisaRefusals.map(_ => false), false]);
                  }
                  toggleModal(index, showModalVisasRefusals, setShowModalVisasRefusals);
                }}
              />
            </CardWithModal>
          ))}
        </CardContainer>
      )}

      {props.prevNonUKVisaRefusalVisible && (
        <RadioOptionsWithConfirm
          key={Q.PREV_NON_UK_VISA_REFUSAL}
          id={Q.PREV_NON_UK_VISA_REFUSAL}
          label={'Have you received a visa refusal from any country (non-UK) in your lifetime?'}
          inputHelperText={props.prevNonUKVisaRefusalConfig?.helpText}
          onClick={(question: { char: string; label: string; selected: boolean }) =>
            handleYesNoClick(Q.PREV_NON_UK_VISA_REFUSAL, question)
          }
          isInline={true}
          questions={[
            {
              char: 'Y',
              label: 'Yes',
              selected: props.hasOtherVisaRefusals === true,
            },
            {
              char: 'N',
              label: 'No',
              selected: props.hasOtherVisaRefusals === false,
            },
          ]}
        />
      )}

      {props.hasOtherVisaRefusals && (
        <CardContainer title={`Non-UK Visa Refusals`}>
          {otherVisaRefusals.map((visa: IStudentNonUKVisaRefusal, index: number) => (
            <CardWithModal
              key={index}
              id={`visa-refusal-${index}`}
              index={index}
              additionalDataSelectorName={'non-uk-visa-refusal'}
              modalTitle={'Add a Non-UK Visa Refusal'}
              cardTitle={`${visa.country} Visa Refusal`}
              cardItems={[
                {
                  label: 'Year',
                  value: visa.year,
                },
                {
                  label: 'Student Visa',
                  value: visa.isStudentVisa ? 'Yes' : 'No',
                },
              ]}
              addButtonLabel={`Add Previous Non-UK Visa Refusal`}
              addAnotherButtonLabel={`I have another visa refusal to add`}
              hasAddMoreButton={visa.country === '' && visa.year === '' && visa.isStudentVisa === undefined}
              onRemove={(removeIndex: number) =>
                deleteVisa<IStudentNonUKVisaRefusal>(
                  removeIndex,
                  [...props.otherVisaRefusals],
                  Q.PREV_NON_UK_VISA_REFUSALS,
                  setOtherVisaRefusals,
                  setShowModalOtherVisaRefusals,
                  { country: '', year: '', isStudentVisa: undefined },
                )
              }
              toggleModal={(value: number) =>
                toggleModal(value, showModalOtherVisaRefusals, setShowModalOtherVisaRefusals)
              }
              showModal={showModalOtherVisaRefusals[index]}
            >
              <NonUKVisaRefusals
                index={index}
                country={visa.country}
                year={visa.year}
                isStudentVisa={visa.isStudentVisa}
                onSaveAndClose={(visaOnSave: IStudentNonUKVisaRefusal) => {
                  const stateOtherVisaRefusals = [...otherVisaRefusals];
                  stateOtherVisaRefusals.pop();
                  const newOtherVisaRefusals = [...props.otherVisaRefusals];
                  newOtherVisaRefusals[index] = {
                    ...visaOnSave,
                  };
                  onChange(Q.PREV_NON_UK_VISA_REFUSALS, newOtherVisaRefusals);
                  if (JSON.stringify(stateOtherVisaRefusals) !== JSON.stringify(newOtherVisaRefusals)) {
                    setOtherVisaRefusals([
                      ...(newOtherVisaRefusals?.length ? newOtherVisaRefusals : []),
                      {
                        country: '',
                        year: '',
                        isStudentVisa: undefined,
                      },
                    ]);
                    setShowModalOtherVisaRefusals([...newOtherVisaRefusals.map(_ => false), false]);
                  }
                  toggleModal(index, showModalOtherVisaRefusals, setShowModalOtherVisaRefusals);
                }}
              />
            </CardWithModal>
          ))}
        </CardContainer>
      )}
    </QuestionPage>
  );
};

export default HistoryQPage2;
